import type { ReactNode } from "react";

/** A cockpit column's 48px header: an uppercase name, and whatever belongs at its right. */
export function ColumnHead({ title, aside }: { title: ReactNode; aside?: ReactNode }) {
  return (
    <div className="flex h-12 shrink-0 items-center justify-between gap-2 border-b border-[color:var(--color-line)] px-4">
      <span className="min-w-0 truncate text-[11px] font-extrabold tracking-[0.12em] text-white/50 uppercase">
        {title}
      </span>
      {aside && <span className="shrink-0 text-xs font-semibold text-white/50">{aside}</span>}
    </div>
  );
}
